// extracted by mini-css-extract-plugin
export default {"root":"SqbEzlpdUkrK3eCHy5Pr","wrap":"D3ORvKiuwPtk5U2BOomS","title":"v3FXi8DDDAnsCEJNt30e","date":"CE_AH50LShq1rwC6qdPR","text":"B49zbKBF9M9r9zwnaR4V"};